import _ from 'lodash';

import { CLAIMS_ACTION_TYPE, ROLES_ACTION_TYPE } from 'store/global/actions';

const initialState = {};

const rolesReducer = function (state = initialState, { payload, type, meta }) {
  switch (type) {
    case ROLES_ACTION_TYPE.GET_ROLES:
      return payload || initialState;

    case ROLES_ACTION_TYPE.ADD_ROLE:
    case ROLES_ACTION_TYPE.EDIT_ROLE:
    case ROLES_ACTION_TYPE.DUPLICATE_ROLE:
      return { ...state, [payload.id]: payload };

    case ROLES_ACTION_TYPE.DELETE_ROLE:
      return _.omit(state, meta.id);

    case ROLES_ACTION_TYPE.MERGE_ROLES:
      // Shallow-merge each role's metadata (id/name) onto any existing entry so it can't clobber
      // claims hydrated in parallel (used for the broker allowed-roles name backfill).
      return Object.entries(payload).reduce(
        (acc, [id, role]) => ({ ...acc, [id]: { ...acc[id], ...role } }),
        state,
      );

    case CLAIMS_ACTION_TYPE.GET_CLAIMS_ROLE_BY_ROLE_ID: {
      const { roleId, data } = payload;

      // Carry the id so a role hydrated ONLY from its claims (e.g. a scoped broker whose company
      // roles list is 403'd) still keys correctly through selectors that re-map by `role.id` —
      // otherwise `currentRole` is lost and its granted claims render as unselected.
      return { ...state, [roleId]: { ...state[roleId], id: roleId, claims: data } };
    }

    default:
      return state;
  }
};

export default rolesReducer;
